
import { signInWithPopup, OAuthProvider } from "firebase/auth";
import { mapActions, mapGetters } from "vuex";
import UiIcon from "~/components/UI/UiIcon.vue";
export default {
  name: "SocialAuth",
  components: { UiIcon },
  data() {
    return {
      providers: [
        { id: "google.com", name: "Google", icon: "social-logo/google" },
        { id: "facebook.com", name: "Facebook", icon: "social-logo/facebook" },
        { id: "apple.com", name: "Apple", icon: "social-logo/apple" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      cartInfo: "cart/getCartInfo",
    }),
  },
  methods: {
    ...mapActions({
      setUserInfo: "auth/setUserInfo",
      getCart: "getCart",
      getWishList: "getWishList",
      getCompareList: "getCompareList",
    }),
    getProviderScopes(providerId) {
      switch (providerId) {
        case "google.com":
          return ["profile", "email"];
        case "facebook.com":
          return ["public_profile", "email"];

        case "apple.com":
          return ["name", "email"];

        default:
          return [];
      }
    },
    async authByProviderId(providerId) {
      const provider = new OAuthProvider(providerId);
      const scopes = this.getProviderScopes(providerId);
      scopes.forEach((scope) => {
        provider.addScope(scope);
      });

      provider.setCustomParameters({
        locale: this.$i18n.locale,
      });

      try {
        const result = await signInWithPopup(this.$socialAuth.auth, provider);

        if (result.user) {
          const params = {
            token: result.user.accessToken,
          };
          if (this.cartInfo?.unique_id) {
            params.cart_unique_id = this.cartInfo.unique_id;
          }

          const response = await this.$api.auth.socialAuth(params);

          const userData = JSON.parse(JSON.stringify(response.data.data));
          delete userData.role;
          delete userData.action;
          await this.setUserInfo(userData);
          await Promise.all([
            this.getCart(),
            this.getWishList(),
            this.getCompareList(),
          ]);
          this.$emit("success", {
            firebaseResult: result,
            userData: response.data.data,
          });
        } else {
          this.$emit("failed");
        }
      } catch (error) {
        this.$emit("failed");
        console.error(error);
      }
    },
  },
};
